var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardClub2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75522 1.80464C3.68915 1.80464 3.62657 1.81126 3.56746 1.81788C3.68568 1.63576 3.75522 1.42053 3.75522 1.19205C3.75522 0.533113 3.19541 0 2.50348 0C1.81154 0 1.25174 0.533113 1.25174 1.19205C1.25174 1.42384 1.32128 1.63576 1.4395 1.81788C1.37691 1.80795 1.31433 1.80464 1.25174 1.80464C0.559805 1.80464 0 2.33775 0 2.99669C0 3.65563 0.559805 4.18874 1.25174 4.18874C1.67594 4.18874 2.04798 3.98676 2.27399 3.68212C2.2879 4.23179 2.10709 4.66556 1.75591 5H3.24409C2.89638 4.66556 2.71558 4.23179 2.72601 3.68212C2.95202 3.98676 3.32406 4.18874 3.74826 4.18874C4.44019 4.18874 5 3.65563 5 2.99669C5 2.33775 4.44367 1.80464 3.75522 1.80464Z",
    fill: "url(#paint0_linear_7297_22283)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7297_22283",
    x1: 0.833553,
    y1: 1.09901,
    x2: 4.01037,
    y2: 4.43524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardClub2);
export default __webpack_public_path__ + "static/media/cardClub2.1150b550eb3cf5fb9bb537567100687f.svg";
export { ForwardRef as ReactComponent };